import { Card } from "@/components/ui/card";
import { Lightbulb } from "lucide-react";
import { ReactNode } from "react";

interface ProTipCardProps {
  children: ReactNode;
}

export function ProTipCard({ children }: ProTipCardProps) {
  return (
    <Card className="p-6 bg-gradient-to-br from-yellow-500/10 via-amber-500/10 to-orange-500/10 border-yellow-500/30">
      <div className="flex gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-yellow-500/20">
          <Lightbulb className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-yellow-900 dark:text-yellow-100 mb-2">
            Pro Tip
          </h4>
          <div className="text-sm text-yellow-800 dark:text-yellow-200">
            {children}
          </div>
        </div>
      </div>
    </Card>
  );
}
